import React, {useState} from 'react';
import {Accordion, AccordionSummary, Box, Stack, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {TAccordion, TStep} from "@/components/forms/Accordion/types";
import AccordionDetailsCustom from "@/components/forms/Accordion/components/AccordionDetailsCustom";

export const AccordionWrapper = ({steps, defaultExpanded, showOnlyOneTab}: TAccordion): any => {

    const [expanded, setExpanded] = useState<number>(defaultExpanded || 0);

    const handleChange = (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : 0);
    };

    return (
        <React.Fragment>
            {
                steps.map(({id, title, key, component, subtitle, icon, hasIndex, hasError, iconError}: TStep, index: number) => {
                    let accordionProps: any = {
                        TransitionProps: {unmountOnExit: false},
                        defaultExpanded: (defaultExpanded !== undefined) ? expanded === index : false
                    }

                    if (showOnlyOneTab) {
                        accordionProps = {
                            ...accordionProps,
                            expanded: expanded === index,
                            onChange: handleChange(index)
                        }
                    }

                    return (
                        <Accordion
                            key={key}
                            {...accordionProps}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls={key}
                                id={id}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    {
                                        hasIndex &&
                                        <Typography variant={(subtitle) ? "h2" : "h6"} sx={{fontWeight: "bold"}}>
                                            {index + 1}
                                        </Typography>
                                    }

                                    {
                                        iconError &&
                                        <Stack
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            spacing={2}
                                            sx={{mr: 0}}
                                        >
                                            <Typography>
                                                {iconError}
                                            </Typography>
                                        </Stack>
                                    }

                                    <Stack>
                                        <Typography variant={"h5"} sx={{color: (hasError) ? 'primary.main' : 'primary.main'}}>
                                            {title}
                                        </Typography>

                                        {
                                            subtitle &&
                                            <Typography sx={{color: 'text.secondary'}}>
                                                {subtitle}
                                            </Typography>
                                        }
                                    </Stack>
                                </Stack>

                                <Box sx={{flexGrow: 1}}/>

                                {
                                    icon &&
                                    <Stack
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                        sx={{mr: 1}}
                                    >
                                        <Typography>
                                            {icon}
                                        </Typography>
                                    </Stack>
                                }
                            </AccordionSummary>
                            <AccordionDetailsCustom component={component}/>
                        </Accordion>
                    );
                })
            }
        </React.Fragment>
    );
}

export default AccordionWrapper;
